import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconSvg from './IconSvg';

const sizes = {
  small: {
    box: 24,
    spacing: 6,
  },
  medium: {
    box: 30,
    spacing: 8,
  },
  large: {
    box: 40,
    spacing: 10,
  },
  xl: {
    box: 50,
    spacing: 16,
  },
  xxl: {
    box: 60,
  },
};

const StyledIconSpan = styled.span`
  --icon-spacing: ${props => props.spacing}px;
  --icon-boxSize: ${props => props.boxSize}px;

  svg {
    height: var(--icon-boxSize);
    width: var(--icon-boxSize);

    vertical-align: middle;

    path {
      fill: ${props => props.fill};
    }
  }
`;

const Icon = (props) => {
  const { name, size, ...propsToPass } = props;

  const { box, spacing } = sizes[size];

  return (
    <StyledIconSpan
      spacing={spacing}
      boxSize={box}
      {...propsToPass}
    >
      <IconSvg name={name} />
    </StyledIconSpan>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
};

export const IconLeft = styled(Icon)`
  svg {
    margin-right: var(--icon-spacing);
  }
`;

export const IconRight = styled(Icon)`
  svg {
    margin-left: var(--icon-spacing);
  }
`;

export default Icon;
